export const RIP_OFF_QUESTIONS = [
  {
    id: "outcome",
    question: "Was your claim denied outright, or approved for less than you expected?",
    options: [
      "Denied completely",
      "Approved, but the amount felt low",
      "Still waiting / being delayed",
      "Approved and paid fairly",
    ],
  },
  {
    id: "explanation",
    question: "Did the insurance company clearly explain why they made that decision — in writing?",
    options: [
      "Yes, clearly and in writing",
      "Some explanation, but confusing",
      "Vague or verbal only",
      "No real explanation at all",
    ],
  },
  {
    id: "documents",
    question: "Were you asked for the same documents or information more than once?",
    options: ["Yes, repeatedly", "Once or twice", "No", "Not sure"],
  },
  {
    id: "scope",
    question: "Did the decision account for the full scope of your damage or loss?",
    options: [
      "Yes, everything was included",
      "Some things were ignored or minimized",
      "Major items were left out",
      "I'm not sure",
    ],
  },
  {
    id: "pressure",
    question: 'Did you feel pressured to accept the decision quickly or "move on"?',
    options: ["Yes, definitely", "Some pressure", "No pressure", "Not applicable"],
  },
];
